import { Announcement } from '@insurancemenu/imenu-components-lib/dist/types/AnnouncementsModal';
import { GET_ANNOUNCEMENTS } from 'api/announcementService';
import apolloClient from 'api/apolloClient';
import { makeAutoObservable } from 'mobx';

export default class AnnouncementStore {
  // eslint-disable-next-line class-methods-use-this
  async getAllAnnouncements(): Promise<Announcement[]> {
    const res = await apolloClient.query<{ getAnnouncements: Announcement[] }>({
      query: GET_ANNOUNCEMENTS,
      fetchPolicy: 'no-cache',
    });
    return res.data.getAnnouncements;
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
